// Central config for external / social profiles
export const SOCIAL = {
  facebook: "https://www.facebook.com/GerardoFontaneroElectricista/",
  linkedin: "https://www.linkedin.com/in/homeatopefontaneroelectricista",
  instagram: "https://www.instagram.com/homeatope/",
  x: "https://x.com/homeatope",
  youtube: "https://www.youtube.com/@fontanerosantiagodecompost8252",
  googleMaps: "https://maps.app.goo.gl/166C8jLpWjkS9Vdo6",
  googleReviews:
    "https://www.google.es/maps/place/Home+a+Tope/@42.8815277,-8.5466312,18z/data=!4m16!1m7!3m6!1s0xd2e56c250ee31b3:0xd8da82aa512a61f8!2sHome+a+Tope!8m2!3d42.8815277!4d-8.5466312!16s%2Fg%2F1tm89qp_!3m7!1s0xd2e56c250ee31b3:0xd8da82aa512a61f8!8m2!3d42.8815277!4d-8.5466312!9m1!1b1!16s%2Fg%2F1tm89qp_",
  blog: "https://fontanerohomeatopelectricista.com",
  youtubeReel: "https://www.youtube.com/shorts/vlyNy6KsQTo",
};

export const CONTACT = {
  phoneDisplay: "669 024 616",
  phoneTel: "+34669024616",
  email: "homeatope@gmail.com",
  whatsappUrl:
    "https://wa.me/34669024616?text=" +
    encodeURIComponent("Hola, escribo desde la web de Home a tope."),
};

export const REVIEWS = {
  rating: 4.7,
  count: 180,
};
